import { LanguageStrings } from "$/strings";

export const en: LanguageStrings = {
  hello: "Hello",
  loading: "Loading...",
  play: "PLAY",
  create: "CREATE",
  choosePetButton: "Choose Pet",
  lowSatietyNotification:
    "Your pet is hungry 🍗. Feed it before it gets worse…",
  lowCleanNotification: "Your pet got dirty 🧼. Time for a bath!",
  lowEnergyNotification:
    "Your pet looks sleepy 😴. Put it to sleep to restore energy.",
  lowMoodNotification: "Your pet is bored 🥺. Play with it to lift its mood!",
  lowHealthNotification: `⚠️ Your little friend really needs your help!
He doesn't feel well and might leave soon… 😢
Come play with him and help him feel better 🐾
Your care is very important ❤️`,
  manyPoopNotification:
    "It seems dirty around your pet… clean up 💩 so it feels better 🧹",
  petLeaveNotification:
    "Your pet left… You didn't take care of it properly 💔 You can revive it or get a new friend.",
  petNotYetCreatedNotification: `🐣  You haven't created your little friend yet!

Tap the Play button, choose the pet you want to create, tap on the egg — and it will hatch ✨

If you encounter problems creating your pet or something doesn't work, please write to us in @telegochigame — we'll be happy to help ❤️`,
  startCommandNoPetText: `Hello! ✨
Time to get your pet 🐾
Choose one of the friends and help it hatch from the egg.

If you want to go through the tutorial — enter /help 📖
If you want to know whose pet lives the longest — check /leaderboard 🏆
If you want to see the best mini-game players — check /leaderboard_game 🎮
If you want to see your pet's stats - /stats 📊
If you want to support the project - /donate ❤️
Invite a friend and earn 20 crystals 💎 — /share
If you want to get a reward for daily entry - /daily 🎉`,
  startCommandHasPetText: `Welcome back! 🌸
Your pet is waiting for your attention. Check its condition and help it become happy.

If you want to go through the tutorial again — enter /help 📖
If you want to know whose pet lives the longest — check /leaderboard 🏆
If you want to see the best mini-game players — check /leaderboard_game 🎮
If you want to see your pet's stats - /stats 📊
If you want to support the project - /donate ❤️
Invite a friend and earn 20 crystals 💎 — /share
If you want to get a reward for daily entry - /daily 🎉`,
  startCommandPetLeaveText:
    `Your pet left… You didn't take care of it properly 💔 You can revive it or get a new friend.

If you want to go through the tutorial — enter /help 📖
If you want to know whose pet lives the longest — check /leaderboard 🏆
If you want to see the best mini-game players — check /leaderboard_game 🎮
If you want to see your pet's stats - /stats 📊
If you want to support the project - /donate ❤️
Invite a friend and earn 20 crystals 💎 — /share
If you want to get a reward for daily entry - /daily 🎉`,
  secondDayNotification:
    `You already spent two days taking care of your pet! He's happy to have you here🥹
The reward is available to you: {eggs} crystals 💎. You can glue the crystals by command /daily.
Come back here every day and collect daily bonuses for taking care of your pet!`,
  petCreatedNotification: `Your pet {name} successfully created!
Don't forget to take care of it, so it doesn't leave.

To be informed of all updates and new features, follow us on our channel 👇
@telegochigame`,
  petRevivedNotification: `Your pet {name} returned!
Don't forget to take care of it, so it doesn't leave.`,
  referalUserCreatedNotification:
    `Your friend has joined via your referral link, and you're getting a reward of {eggs} crystals!`,
  dailyCommandSuccess: `Received: {eggs} crystals 💎.
Come back here every day and collect daily bonuses for taking care of your pet!`,
  dailyCommandFail:
    `Daily bonus is not available❌ Check compliance with the Conditions:
    - The bonus can be branded only once a day.
    - You visit your pet for 2 or more consecutive days.
    - You have a pet.`,
  dailyCommandFailNoAlivePet: `Daily bonus is not available❌
  You don't have a pet to take care of.`,
  dailyCommandFailNotDailyStartActivated: `Daily bonus is not available❌
  You haven't started the daily yet.`,
  dailyCommandFailTodayAlreadyClaimed: `Daily bonus is not available❌
  You already claimed it today.`,
  onboarding: {
    start:
      `First, choose one of the pets. It will appear in an egg 🥚 — help it hatch (tap the egg until it cracks!).
When it appears, it will have four important needs: satiety, cleanliness, energy, and mood.
Your task is to maintain your pet's happiness and not let any characteristic drop to 0, otherwise the pet will leave forever 💔
For taking care of it, you receive crystals 💎 — you can spend them on your pet's happiness and restoring all characteristics.
Choose what you'd like to learn more about next:`,
    satiety: `Satiety
Your pet wants to eat!
To feed it, just scatter food around the field, and the pet will run to it and eat😋
If the food runs out, buy it for crystals 💎 in the store.
Remember that the pet can't eat by itself😓 You can't just scatter food around the field and leave — the pet is waiting for you to eat!`,
    clean: `Cleanliness
The pet, like you, goes to the toilet and takes a shower.
Periodically, the pet leaves poop 💩 on the field — throw it in the trash can and get crystals 💎 in return.
If the pet is too dirty, you need to wash it with soap. But carefully!`,
    energy: `Energy
The pet wants to sleep 💤
Be sure to monitor the change of day and night to maintain the pet's energy.
If the pet has slept enough, it will wake up on its own. Don't forget about it, because only you can put the pet to sleep 🌑
But keep in mind: if you put the pet to sleep too early, it won't be able to fall asleep!`,
    mood: `Mood
The pet loves to play.
Play mini-games with it or, I don't know, try to entertain it with objects on the field…
Playing with the pet is the only way to earn crystals 💎.`,
    eggs: `Crystals
Crystals 💎 are the in-game currency of our tamagotchi.
You need them to buy food or restore characteristics to 100%.
You can earn💰 them by playing mini-games or cleaning up after the pet.`,
  },
  share: "Let a friend get a pet and help you get extra crystals 💎",
  shareMessage: "Get yourself a pet and try to raise him better than others 😼",
  shareMiniGameResultMessage:
    `Try to beat my result in the mini-game - {score}!🏆`,
  donate: `Support the development of Telegochi! 🌟
Choose the amount of Telegram Stars you'd like to donate.
Your contribution helps us maintain and improve the game.

Or use /donate <amount> for a custom amount. Example: /donate 100`,
  donateSuccess:
    "Thank you for your support! Your donation will greatly help the project development.",
  leaderboardTitle: "🏆 Leaderboard - Top 10 Longest Living Pets",
  leaderboardEntry: "#{position} {username} - {days} days",
  leaderboardYourPosition: "\n\nYour pet: {username} - {days} days",
  leaderboardNoPet: "\n\nYou don't have a living pet yet.",
  gameLeaderboardTitle: "🎮 Mini-Game Leaderboard - Top 10 Highest Scores",
  gameLeaderboardEntry: "#{position} {username} - {score} points",
  gameLeaderboardYourPosition: "\n\nYour pet: {username} - {score} points",
  gameLeaderboardNoPet: "\n\nYou don't have a living pet yet.",
  statsTitle: "🐾 Your Pet Status",
  statsInfo:
    "Satiety: {satiety}%\nCleanliness: {clean}%\nEnergy: {energy}%\nMood: {mood}%\nCrystals: {coins} 💎\nFood: {food} 🍗\nPoop: {poop} 💩",
  statsNoPet: "You don't have a living pet yet. Create one to start playing!",

  petNames: {
    cat: "Cat",
    dog: "Dog",
    capy: "Capybara",
    parrot: "Parrot",
    shark: "Shark",
  },

  yourPetDead: "Your pet is dead...",
  savePet: "Save it while you can!",
  saveProgress: "Save all progress and items!",
  loseProgress: "All progress will be lost!",
  or: "or",
  resurrectButton: "Resurrect",
  resurrectByAdButton: "Revive with Ad",
  createNewButton: "Create new",
  settings: "Settings",
  catchFoodScene: {
    score: "Score",
    miss: "Missed",
    obstacleCatched: "Poisoned",
    again: "Restart",
    leaderboard: "Leaderboard",
    continueTitle: "Continue Game?",
    continueButton: "Continue",
    resultsButton: "To Results",
    timer: "Time left",
    share: "Share",
    exit: "Exit",
    newRecord: "New record!",
    leaderboardError: "Failed to load leaderboard. Please try again.",
  },
  currencyShopScene: {
    getEggs: "Get eggs",
    invite: "Invite",
    motivationText: "Invite a friend and get eggs when he\ncreates a pet!",
    supportText: "Support \ndevelopers ❤️",
    ourChannelText: "Our channel",
    exit: "Exit",
    donateError: "Error processing donation. Please try again later.",
  },
  statRestoreOverlay: {
    notEnoughCoins: "Not enough coins!",
    energy: "Energy",
    satiety: "Satiety",
    mood: "Mood",
    clean: "Clean",
    restoreWithAd: "Restore",
    adWarningText: "ad will be shown",
  },
  settingsOverlay: {
    music: "Music",
    sound: "Sounds",
  },
  sceneTransitions: {
    backToPet: "Back to Pet!",
    eggsPurchased: "Eggs Purchased!",
    brakeEgg: "Brake the Egg",
    choosePet: "Choose Your Pet ^_^",
    petIsBack: "Your pet is back!",
    petIsDead: "Your pet is dead 😭",
    createPet: "Create Your Pet ^_^",
    welcomeBack: "Welcome Back ^_^",
    goingBack: "Going back...",
    home: "Home...",
    shop: "Shop",
    startingGame: "Starting game...",
    gamesList: "Mini Games",
    
  },
  foodShopOverlay: {
    title: "Buy Food",
    buyFood: "+1 Food",
    currentFood: "Food",
    notEnoughCoins: "Not enough eggs!",
  },
};
